import { jsx } from 'react/jsx-runtime';
import { separator } from './menu-v2.css.js';

/**
 * MenuV2.Separator
 *
 * @compose { "parent": ["MenuV2.Root", "MenuV2.SubMenu", "MenuV2.Group"], "multi": true }
 */
function Separator(props) {
    // eslint-disable-next-line fpl/fpl-data-attr -- always used in context
    return jsx("li", { ...props, className: separator, role: "separator" });
}
Separator.displayName = 'MenuV2.Separator';

export { Separator };
//# sourceMappingURL=menu-v2.separator.js.map
